export default __webpack_public_path__ + "static/media/store-4.43878d9f.jpg";